import Dropdown from "app/components/Dropdown";
import { DropdownIcon, CheckIcon } from "app/components/Icons";
import clsx from "clsx";
import React, { useState, useMemo } from "react";
import { getShortIcon } from "./data";

interface Props {
  options: { key: string | null; label: string }[];
  value: string | null;
  onUpdate: (val: string | null) => void;
}

const FieldSelect: React.FC<Props> = ({ options, value, onUpdate }) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = options.map((opt) => ({
    label: (
      <div
        className={clsx(
          "flex items-center justify-between gap-1.5 rounded-md w-full",
        )}
      >
        <div className="flex items-center gap-2">
          {opt.key !== null && getShortIcon(opt.key)}
          <span className={clsx("text-sm font-normal text-secondary")}>
            {opt.label}
          </span>
        </div>
        {opt.key === value && <CheckIcon color="#5A8DF1" size={18} />}
      </div>
    ),
    action: () => {
      if (opt.key !== value) {
        onUpdate(opt.key);
      }
      setIsOpen(false);
    },
  }));

  // Pretty label + icon for current value
  const current = useMemo(() => {
    const match = options.find((o) => o.key === value);
    return {
      label: match?.label ?? "",
      icon: match?.key ?? "",
    };
  }, [options, value]);

  const isPlaceholder = value === null;

  return (
    <div className="relative">
      <Dropdown
        open={isOpen}
        setOpen={setIsOpen}
        trigger={
          <button
            className={clsx(
              "flex items-center justify-between w-full h-8 rounded border text-sm font-normal outline-none px-2 truncate ",
              isOpen ? "border border-secondary" : "border border-gray-200",
              isPlaceholder ? "text-gray-300" : "text-secondary",
            )}
            aria-label="Select sort field"
            aria-expanded={isOpen}
          >
            <div className="flex items-center gap-2 truncate">
              {!isPlaceholder ? getShortIcon(current.icon) : "Sort by"}
              <span className="truncate">{current.label}</span>
            </div>
            <div
              className={clsx(
                "size-[16px] min-w-[16px] transition-transform duration-300 ease-in-out",
                isOpen ? "rotate-180" : "",
              )}
            >
              <DropdownIcon size={16} />
            </div>
          </button>
        }
        menuItems={menuItems}
      />
    </div>
  );
};

export default FieldSelect;
